import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadConsumerHealthProfile, leadConsumerHealthProfilesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';

const LEAD_CONSUMER_HEALTH_PROFILE_MODULE = 'leadConsumerHealthProfile';

const dataObjectModule = getDataObjectsModule<ILeadConsumerHealthProfile>(leadConsumerHealthProfilesManager);
const searchModule = getSearchModule<ILeadConsumerHealthProfile>(leadConsumerHealthProfilesManager);

const leadConsumerHealthProfileModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(LEAD_CONSUMER_HEALTH_PROFILE_MODULE, leadConsumerHealthProfileModuleInstance);

export { LEAD_CONSUMER_HEALTH_PROFILE_MODULE };
